// Helpers
import {
  SaveDomainSubstitute,
  RemoveDomainSubstitute,
} from "../DomainSubstitute/DomainSubstitute";
// Consts
import stages from "../../consts/stages";
import errorLevels from "../../consts/errorLevels";

const mediaLoadCache: { [key: string]: number } = {};
const usedDomainsAttribute = "isUsedList";

function retryMediaLoad(e: Event, updatedLink?: string) {
  setTimeout(function () {
    if (e.target) {
      const link =
        updatedLink || (e.target as HTMLImageElement | HTMLVideoElement).src;
      const replacedLink = link.replace(/(\?t=).*/, "");

      (e.target as HTMLImageElement | HTMLVideoElement).src =
        replacedLink + "?t=" + +new Date();

      if ((e.target as HTMLVideoElement).tagName === "SOURCE") {
        const parent = (e.target as HTMLVideoElement).parentNode;
        if (parent) {
          (parent as HTMLVideoElement).load();
        }
      }
    }
  }, 1000);
}

export function MediaCatcher(
  e: Event,
  maxCountOfTryingForSource = 2,
  widgetType: string,
  onExceedOfTryingSource?: () => void
) {
  if (!e.target) return;

  const targetElement = e.target as HTMLImageElement | HTMLVideoElement;

  targetElement.onerror = null;

  const madiaTitle = targetElement.src.replace(/(\?t=).*/, "");

  if (typeof mediaLoadCache[madiaTitle] === "undefined") {
    mediaLoadCache[madiaTitle] = 0;
  } else {
    mediaLoadCache[madiaTitle] = mediaLoadCache[madiaTitle] + 1;
  }

  RemoveDomainSubstitute(madiaTitle);

  if (mediaLoadCache[madiaTitle] >= maxCountOfTryingForSource) {
    const originalUrl = new URL(madiaTitle);

    if (!window.frisbuy.domains || !window.frisbuy.errorHandler) {
      // Обработка ошибок для устаревшего типа инициализации
      window.frisbuy.errorHandler.addErrorToQueue({
        type: stages.ASSETS,
        widgetType,
        level: errorLevels.ERROR,
        request: madiaTitle,
        domain: originalUrl.protocol + "//" + originalUrl.hostname,
      });
      return;
    }

    // Сохраняем ошибку после 3 попыток загрузки
    window.frisbuy.errorHandler.addErrorToQueue({
      type: stages.ASSETS,
      widgetType,
      level: errorLevels.ERROR,
      request: madiaTitle,
      domain: originalUrl.protocol + "//" + originalUrl.hostname,
    });

    const unaccessedDomains = [...new Set(window.frisbuy.notaccesed || [])];
    const attribute = targetElement.getAttribute(usedDomainsAttribute);

    const availableDomainIndexes = [...Array(window.frisbuy.domains.length)]
      .map((_, i) => i)
      .filter(
        (index) =>
          !unaccessedDomains.includes(index) &&
          !(attribute || "")
            .split(",")
            .filter((el) => el !== "")
            .map((el) => +el)
            .includes(index)
      );

    if (availableDomainIndexes.length <= 0) {
      window.frisbuy.errorHandler.addErrorToQueue({
        type: stages.ASSETS,
        widgetType,
        level: errorLevels.UNACCESSED,
        request: madiaTitle,
        domain: originalUrl.protocol + "//" + originalUrl.hostname,
      });

      if (onExceedOfTryingSource) {
        onExceedOfTryingSource();
      }
      return;
    }

    const newDomainIndex = Math.round(
      Math.random() * (availableDomainIndexes.length - 1)
    );

    const newDomain = window.frisbuy.domains[newDomainIndex];

    targetElement.setAttribute(
      usedDomainsAttribute,
      `${attribute ? attribute + "," : ""}${
        availableDomainIndexes[newDomainIndex]
      }`
    );

    SaveDomainSubstitute(madiaTitle, newDomain);

    retryMediaLoad(e, newDomain + originalUrl.pathname + originalUrl.search);

    return;
  }

  retryMediaLoad(e);
}
